import { render, staticRenderFns } from "./AdminNoticesTable.vue?vue&type=template&id=6a19e56b&scoped=true"
import script from "./AdminNoticesTable.vue?vue&type=script&lang=js"
export * from "./AdminNoticesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19e56b",
  null
  
)

export default component.exports